import Vue from 'vue'
import Vuex from 'vuex'


//挂载Vuex
Vue.use(Vuex);
const store = new Vuex.Store({
  state:{
    //存放的键值对就是所要管理的状态
    tabNames:'1'
  },
  getters: {
    tabNames_get: state => state.tabNames,
  },
  mutations:{
    //es6语法，等同edit:funcion(){...}
    changeTab(state, n) {
      state.tabNames = n;
    },
  },
  actions:{
    changeTab(context, n) {
      context.commit('changeTab', n);
    },
  }

});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js